import { createSelector } from 'reselect';

import Ps          from 'app/helpers/publish-statuses';
import BuilderSlx  from 'app/selectors/company-admin/builder-group';

const selGroup = createSelector(
  [BuilderSlx.saveAttrs],
  (saveAttrs) => {
    return {
      ...saveAttrs,
      publishStatus: Ps.DRAFT,
    };
  }
);

export default {
  group: selGroup,
};
